<div class="page-content">
    <p-panel header="User Roles management" class="no-x-padding">
        <app-user-role-crud></app-user-role-crud>
    </p-panel>
</div>
